<template>
  <div class="center-chart-0">
    <span class="center-header">累计总人数：</span>
    <span class="center-count">
        {{ incdata }}
    </span>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'LayoutLeft3',
  data () {
    return {
        wholenum: 0,
        alldata: {},
      all: {
        scene: 100,
        attendance: 10000,
      },
    }
  },
  mounted() {
    this.loadList();
  },
  computed: {
    incdata() {
        return this.wholenum + this.$store.state.incdata
    }
  },
  methods: {

      loadList() {
          var that = this;
          axios.get(this.$store.state.config.host + "/v1/block/" + window.encodeURI('数据大屏_概览数据') + '/?cid=4000').then(response => {
              //   that.alldata = response.data.data;
              Object.values(response.data.data).forEach(element => {
                  that.alldata[element.title] = element.title1;
              });
              const num = Number(that.alldata['累计总人数']);
              that.wholenum = num;
          })
      },
  }
}
</script>

<style lang="less">
.center-chart-0 {
  width: 100%;
  height: 100%;
//   flex-grow: 0;
//   flex-direction: row;
  text-align: center;
  
  .center-header {
    font-size: 20px;
  }

  .center-count {
    height: 100%;
    font-size: 32px;
  }
}
</style>


